<div class="wrapper">
    <p class="info-text">
        Follow instructions below to complete creation. If you have any questions,
        <span class="contact-link" (click)="onContactClick($event)" role="button" tabindex="0" [attr.aria-label]="'Contact support team'"
            (keydown.enter)="onContactClick($event)" (keydown.space)="onContactClick($event)">contact our support</span>
        team for further assistance.
    </p>

    <div class="accordion" id="createSessionsStepsAccordion">
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#createSession" aria-controls="createSession"
                    [class.collapsed]="!createSessionActiveStep || isAddSuppliersStepActive" (click)="onCreateSessionClick()">
                    <strong>3.1 Create a Session</strong>
                </button>
            </h2>
            <div id="createSession" class="accordion-collapse collapse" [class.show]="isCreateSessionStepActive" data-bs-parent="#createSessionsStepsAccordion">
                <div class="accordion-body">
                    <div class="text-wrapper">
                        <ul class="conditions-list">
                            <li>
                                Go to Integration settings → SMPP & Suppliers and click <strong>Create session.</strong>
                            </li>
                            <li>Fill in Login, Password, Host, Port in order to connect to your SMPP server.</li>
                            <li>
                                After saving the session, the Host dot becomes green once the session is online, which
                                can take up to a few minutes.
                            </li>

                            <p class="conditions-info-text">
                                <strong> Dot stays red? </strong>
                                Check firewall (IP allowlist), credentials, host/port. Click the bug icon in Actions to
                                see the last error. You can toggle disable/enable to restart a session.
                            </p>
                            <li>
                                <strong>Need to bulk-create?</strong> Use Import from Excel option on the SMPP &
                                Suppliers page next to Create session button.
                            </li>
                        </ul>
                    </div>

                    <img class="image-help" src="img/smpp_integration_create_session.png" alt="Create a session" />
                </div>
            </div>
        </div>
        <div class="accordion-item">
            <h2 class="accordion-header">
                <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#addSuppliers" aria-controls="addSuppliers"
                    [class.collapsed]="!createSessionActiveStep || isCreateSessionStepActive" (click)="onAddSuppliersClick()">
                    <strong>3.2 Add Suppliers</strong>
                </button>
            </h2>
            <div [class.show]="isAddSuppliersStepActive" id="addSuppliers" class="accordion-collapse collapse" data-bs-parent="#createSessionsStepsAccordion">
                <div class="accordion-body">
                    <div class="text-wrapper">
                        <ul class="conditions-list">
                            <li>Click <strong>Add supplier </strong> the session row.</li>
                            <li>
                                Fill <strong>Supplier Name</strong> and <strong>Route Type</strong> (other attributes
                                are optional, use them if you need)
                            </li>
                            <li>
                                <strong>If you're using Service Type (recommended):</strong> Go to Routing Parameters
                                tab and set <strong>Service Type </strong>to the exact value your platform expects for
                                that supplier. Result will be multiple suppliers can share the same SMPP session.
                            </li>
                            <li>
                                <strong>If you're not using Service Type:</strong> Create one session per supplier and
                                link the supplier to its dedicated session.
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
